<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-traffic-lights"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <rect
      x="7"
      y="2"
      width="10"
      height="20"
      rx="5"
    />
    <circle
      cx="12"
      cy="7"
      r="1"
    />
    <circle
      cx="12"
      cy="12"
      r="1"
    />
    <circle
      cx="12"
      cy="17"
      r="1"
    />
  </svg>
</template>

<style lang="scss" scoped>
.icon-tabler {
  stroke-width: 1.25;
}
</style>
